import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' }, ,
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    city: {
      validations: []
    },
    state: {
      validations: []
    },
    postal: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select a date for your event' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please provide the number of guests' }
      ]
    },
    sitename: {
      validations: [
        { type: 'required', message: 'Please provide the name of the location or venue' }
      ]
    },
    accountextra2: {
      validations: [
        { type: 'required', message: 'Please provide a reference' }
      ]
    },
    accountextra9: {
      validations: []
    },
    Website: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name: *',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name: *',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number: *',
            mapping: 'telNumber'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'E-mail Address: *',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City:',
            mapping: 'city'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State:',
            options: [
              { label: 'AL', value: 'AL' },
              { label: 'AK', value: 'AK' },
              { label: 'AZ', value: 'AZ' },
              { label: 'AR', value: 'AR' },
              { label: 'CA', value: 'CA' },
              { label: 'CO', value: 'CO' },
              { label: 'CT', value: 'CT' },
              { label: 'DE', value: 'DE' },
              { label: 'DC', value: 'DC' },
              { label: 'FL', value: 'FL' },
              { label: 'GA', value: 'GA' },
              { label: 'HI', value: 'HI' },
              { label: 'ID', value: 'ID' },
              { label: 'IL', value: 'IL' },
              { label: 'IN', value: 'IN' },
              { label: 'IA', value: 'IA' },
              { label: 'KS', value: 'KS' },
              { label: 'KY', value: 'KY' },
              { label: 'LA', value: 'LA' },
              { label: 'ME', value: 'ME' },
              { label: 'MD', value: 'MD' },
              { label: 'MA', value: 'MA' },
              { label: 'MI', value: 'MI' },
              { label: 'MN', value: 'MN' },
              { label: 'MS', value: 'MS' },
              { label: 'MO', value: 'MO' },
              { label: 'MT', value: 'MT' },
              { label: 'NE', value: 'NE' },
              { label: 'NV', value: 'NV' },
              { label: 'NH', value: 'NH' },
              { label: 'NJ', value: 'NJ' },
              { label: 'NM', value: 'NM' },
              { label: 'NY', value: 'NY' },
              { label: 'NC', value: 'NC' },
              { label: 'ND', value: 'ND' },
              { label: 'OH', value: 'OH' },
              { label: 'OK', value: 'OK' },
              { label: 'OR', value: 'OR' },
              { label: 'PA', value: 'PA' },
              { label: 'RI', value: 'RI' },
              { label: 'SC', value: 'SC' },
              { label: 'SD', value: 'SD' },
              { label: 'TN', value: 'TN' },
              { label: 'TX', value: 'TX' },
              { label: 'UT', value: 'UT' },
              { label: 'VT', value: 'VT' },
              { label: 'VA', value: 'VA' },
              { label: 'WA', value: 'WA' },
              { label: 'WV', value: 'WV' },
              { label: 'WI', value: 'WI' },
              { label: 'WY', value: 'WY' }
            ],
            mapping: 'state'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip Code:',
            mapping: 'postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'XLarge',
            label: 'Event Date (MM/DD/YYYY): *',
            mapping: 'eventDate'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Est. Guest Count: *',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Where would you like to host your event?: *',
            options: [
	            { label: 'Calderwood Courtyard', value: 'Calderwood Courtyard'},
              { label: 'Adolphus Busch Hall', value: 'Adolphus Busch Hall'},
              { label: 'Boston Public Library', value: 'Boston Public Library'},
              { label: 'Institute of Contemporary Art', value: 'Institute of Contemporary Art'},
              { label: 'Harvard Art Museums', value: 'Harvard Art Museums'},
              { label: 'Boston Athenaeum', value: 'Boston Athenaeum'},
              { label: 'SoWa Powerstation', value: 'SoWa Powerstation'},
	            { label: 'Boston Lyric Opera', value: 'Boston Lyric Opera'},
              { label: 'Midtown Race Club', value: 'Midtown Race Club'},
              { label: 'Home', value: 'Home'},
              { label: 'Office', value: 'Office'},
              { label: 'Tented', value: 'Tented'},
              { label: 'Other Venue', value: 'Other Venue'},
            ],
            mapping: 'sitename'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Referred By: *',
            options: [
              { label: 'Search Engine'  , value: 'Search Engine'},
              { label: 'Google Ad'  , value: 'Google Ad'},
              { label: 'AI Search (ChatGPT, etc.)'  , value: 'AI Search (ChatGPT, etc.)'},
              { label: 'Social Media'  , value: 'Social Media'},
              { label: 'Planner / DMC'  , value: 'Planner / DMC'},
              { label: 'PartySlate'  , value: 'PartySlate'},
              { label: 'Meet Boston'  , value: 'Meet Boston'},
              { label: 'Venue Referral'  , value: 'Venue Referral'},
              { label: 'Friend or Family Referral'  , value: 'Friend or Family Referral'},
              { label: 'Other'  , value: 'Other'},
            ],
            mapping: 'accountextra2'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'If Other, please provide reference:',
            mapping: 'accountextra9'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Please tell us more about your event:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SEND'
          }
        ]
      }
    ]
  },
  info: {
    title: 'TCA-HAM Wedding Contact Form (322)',
    formId: '322',
    clientKey: 'B46D4299-E772-4E44-9F26-2D7CBE3D9B91',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://www.thecateredaffair.com/harvardart-success',
    submissionText: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
